import _ from 'lodash';
import { TravelTypes } from '../constants';
import formatPriceRequest from '../helpers/formatPriceRequest';
import getPriceBreakdownKey from '../helpers/getPriceBreakdownKey';
import getCruisePriceBreakdownTotals from '../helpers/getCruisePriceBreakdownTotals';

export default function calculateAgentTipCommissions(
  cruisePriceBreakdowns,
  agentTipItineraries,
  staterooms,
) {
  const commissions = {
    commissionAgentTip: null,
    commissionCruise: 0,
    commissionHotel: 0,
    commissionFlight: 0,
  };

  agentTipItineraries.forEach((agentTipItinerary) => {
    if (agentTipItinerary.mode === TravelTypes.hotel) {
      commissions.commissionHotel = _.get(agentTipItinerary, 'selectedProduct.roomPrice.agentCommission');
    }
    if (agentTipItinerary.mode === TravelTypes.cruise) {
      commissions.commissionCruise = null;
      const cruisePriceBreakdownKey = getPriceBreakdownKey(formatPriceRequest({
        itineraryId: agentTipItinerary.travelOption.itineraryRows[0].itineraryId,
        cruiseLineId: agentTipItinerary.travelOption.cruiseLine.cruiseLineId,
        staterooms,
      }));
      if (!cruisePriceBreakdowns[cruisePriceBreakdownKey]) {
        return false;
      }
      const totals = getCruisePriceBreakdownTotals(cruisePriceBreakdowns[cruisePriceBreakdownKey]);
      commissions.commissionCruise = totals.commission.amount;
    }
    return null;
  });

  if (commissions.commissionCruise !== null) {
    commissions.commissionAgentTip = commissions.commissionCruise
      + commissions.commissionHotel
      + commissions.commissionFlight;
  }
  return commissions;
}
